import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'ReliaCore',
  brandName: 'ReliaCore',
  description: 'Sistema de agendamento para técnicos de manutenção',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Técnico de manutenção em serviço',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Trabalhos de reparação doméstica',
  },
  testimonials: [
    {
      name: 'António Lopes',
      role: 'Técnico de Manutenção',
      text: 'O ReliaCore ajuda-me a organizar as minhas visitas diárias. Os clientes podem agendar online e eu recebo tudo no telemóvel.',
      image: testimonial1,
    },
    {
      name: 'Maria João',
      role: 'Cliente',
      text: 'Precisei de uma reparação urgente e consegui agendar com um técnico em 5 minutos. Fantástico!',
      image: testimonial2,
    },
    {
      name: 'SOS-Reparos',
      role: 'Empresa de Manutenção',
      text: 'Gestão de equipas e agendamentos muito mais fácil. Aumentámos a nossa eficiência em 30%.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'técnico de manutenção',
    professionals: 'técnicos de manutenção',
    business: 'empresa',
    businesses: 'empresas',
    service: 'manutenção',
    services: 'manutenções',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'visita',
    appointments: 'visitas',
  },
  homepage: {
    hero: {
      badge: 'Manutenção Confiável',
      title: 'Mantenha tudo funcionando com ReliaCore',
      description: 'Organize suas manutenções e reparações, garantindo que tudo funcione perfeitamente com o ReliaCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '380+', label: 'Técnicos de Manutenção' },
      { value: '31k+', label: 'Manutenções Realizadas' },
      { value: '92%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Emergências Imprevistas',
        description: 'Avarias urgentes desorganizam toda a agenda e afetam outros clientes agendados.',
        icon: 'AlertTriangle',
        quote: {
          text: 'Antes do ReliaCore as emergências bagunçavam minha agenda inteira, agora tenho slots reservados',
          author: 'Carlos Pereira',
          business: 'Manutenção Rápida',
        },
      },
      {
        title: 'Ferramentas Inadequadas',
        description: 'Chegar ao local sem as ferramentas certas resulta em visitas improdutivas e clientes insatisfeitos.',
        icon: 'Tool',
        stats: [
          { label: 'Visitas sem ferramentas adequadas:', value: '25%' },
          { label: 'Tempo perdido em regressos:', value: '15h/semana' },
        ],
      },
      {
        title: 'Contratos de Manutenção',
        description: 'Gerir contratos recorrentes manualmente causa esquecimentos e perda de receita.',
        icon: 'FileCheck',
        quote: {
          text: 'Com o sistema de contratos nunca mais esqueci uma manutenção preventiva agendada',
          author: 'Luís Gonçalves',
          business: 'ProMaintenance',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'ReliaCore: O seu centro de manutenção',
      description: 'Tecnologia robusta para técnicos que querem manter tudo funcionando perfeitamente.',
      features: [
        {
          title: 'Slots de Emergência',
          description: 'Reserve automaticamente períodos para avarias urgentes sem afetar agendamentos regulares.',
        },
        {
          title: 'Lista de Ferramentas',
          description: 'Cada tipo de serviço tem lista pré-definida de ferramentas necessárias para evitar esquecimentos.',
        },
        {
          title: 'Contratos Recorrentes',
          description: 'Automatize manutenções preventivas e gerencie contratos de longo prazo facilmente.',
        },
      ],
    },
    testimonials: {
      title: 'O que os técnicos de manutenção dizem',
      description: 'Técnicos que confiam no ReliaCore para manter tudo funcionando.',
    },
    finalCta: {
      title: 'Pronto para manter tudo em ordem?',
      description: 'Junte-se aos técnicos que já organizaram suas manutenções com o ReliaCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de técnico de manutenção',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
